import { useEffect, useState } from 'react'
import { useQuery } from '@apollo/client/react'
import { AdminAPI, getFragment, SharedAPI } from '@guestgoodie/graphql'
import { useLingui } from '@lingui/react/macro'

import Field from '@/components/ui/Field'
import { QrCodeContent } from '../hooks/useQrCode'
import { SelectStay } from '@/features/stay'

export function DirectLoginUrl({
  appUrl,
  onChange
}: {
  appUrl: string
  onChange: (urls: QrCodeContent[]) => void
}) {
  const { t } = useLingui()

  const [stayId, setStayId] = useState<number | null>(null)

  const { data } = useQuery(AdminAPI.stay.GET, {
    variables: { id: stayId ?? -1, withSpace: true, withGuests: true },
    skip: !stayId
  })

  useEffect(() => {
    const stay = getFragment(SharedAPI.stay.STAY_FRAGMENT, data?.getStay)
    const space = getFragment(SharedAPI.space.SPACE_FRAGMENT, stay?.space)
    const guest = getFragment(SharedAPI.guest.GUEST_FRAGMENT, stay?.guests?.[0])

    if (!stay || !space) return

    const content = {
      spaceIdentifier: space.identifier,
      secret: stay.secret
    }

    const text = guest ? `${guest.firstName} ${guest.lastName}` : undefined
    const token = btoa(JSON.stringify(content))

    onChange([{ url: `${appUrl}/connect/${token}`, text }])
  }, [appUrl, stayId, data, onChange])

  return (
    <div>
      <Field label={t`Choose Stay`} size="small">
        <SelectStay id={stayId} onChange={setStayId} />
      </Field>
    </div>
  )
}
